export default Object.freeze({
  Resolved: 'Resolved',
  Scheduled: 'Scheduled',
  Pending: 'Pending',
  Snoozed: 'Snoozed',
  Declined: 'Declined',
  Dismissed: 'Dismissed',
  Updated: 'Updated',
  Cancelled: 'Cancelled',
  Reschedule_Request: 'Reschedule Request',
  Cancellation_Pending: 'Cancellation Pending',
  Completed: 'Completed',
  Expired: 'Expired',
  Closed: 'Closed',
});
